// Lootbox rarities with drop rates (must sum to 100)
// S1 rates (includes nuclear)
export const LOOTBOX_RARITIES_S1 = {
  COMMON: { name: "Common", color: "#B0B0B0", dropRate: 50, glow: false },
  UNCOMMON: { name: "Uncommon", color: "#5CB85C", dropRate: 30, glow: false },
  RARE: { name: "Rare", color: "#5BC0DE", dropRate: 12, glow: false },
  EPIC: { name: "Epic", color: "#9B59B6", dropRate: 6, glow: true },
  LEGENDARY: { name: "Legendary", color: "#FFD700", dropRate: 1.899, glow: true },
  MYTHIC: { name: "Mythic", color: "#FF1744", dropRate: 0.09, glow: true },
  GALAXY: { name: "Galaxy", color: "#9C27B0", dropRate: 0.01, glow: true, rainbow: true },
  NUCLEAR: { name: "Nuclear", color: "#00FF00", dropRate: 0.001, glow: true, rainbow: true, explosion: true },
  TESTER: { name: "Tester", color: "#FFA500", dropRate: 0, glow: true },
};

// S2 rates (nuclear removed, galaxy absorbs remainder)
export const LOOTBOX_RARITIES_S2 = {
  COMMON: { name: "Common", color: "#B0B0B0", dropRate: 50, glow: false },
  UNCOMMON: { name: "Uncommon", color: "#5CB85C", dropRate: 30, glow: false },
  RARE: { name: "Rare", color: "#5BC0DE", dropRate: 12, glow: false },
  EPIC: { name: "Epic", color: "#9B59B6", dropRate: 6, glow: true },
  LEGENDARY: { name: "Legendary", color: "#FFD700", dropRate: 1.9, glow: true },
  MYTHIC: { name: "Mythic", color: "#FF1744", dropRate: 0.09, glow: true },
  GALAXY: { name: "Galaxy", color: "#9C27B0", dropRate: 0.01, glow: true, rainbow: true },
  TESTER: { name: "Tester", color: "#FFA500", dropRate: 0, glow: true },
};

// Default export — components that don't know about S2 get S1
export const LOOTBOX_RARITIES = LOOTBOX_RARITIES_S1;

// S2 item networth values (per-rarity)
export const S2_ITEM_VALUES = {
  COMMON: 0.10,
  UNCOMMON: 0.25,
  RARE: 0.75,
  EPIC: 2.00,
  LEGENDARY: 5.00,
  MYTHIC: 15.00,
  GALAXY: 75.00,
  NUCLEAR: 400.00,
  TESTER: 0,
};

// S2 modifier multipliers for networth
export const S2_MODIFIER_MULTIPLIERS = {
  shiny: 2,
  vfx: 5,
  // StatTrak: 1.5 + 0.5 per extra stat (calculated dynamically)
};

// S2 shiny chances per rarity (base rates)
export const S2_SHINY_CHANCES = {
  COMMON: 0.05,
  UNCOMMON: 0.05,
  RARE: 0.05,
  EPIC: 0.05,
  LEGENDARY: 0.10,
  MYTHIC: 0.20,
  GALAXY: 0.50,
};

// S2 shiny box multiplier
export const S2_SHINY_BOX_MULTIPLIER = 5;

// Elite lootbox specific drop rates (must sum to 100)
export const ELITE_LOOTBOX_RATES_S1 = {
  EPIC: 55,
  LEGENDARY: 30,
  MYTHIC: 10,
  GALAXY: 4,
  NUCLEAR: 1
};

export const ELITE_LOOTBOX_RATES_S2 = {
  EPIC: 55,
  LEGENDARY: 30,
  MYTHIC: 10,
  GALAXY: 5
};

export const ELITE_LOOTBOX_RATES = ELITE_LOOTBOX_RATES_S1;

// GOD BOX specific drop rates (must sum to 100)
export const GOD_BOX_RATES_S1 = {
  COMMON: 5,
  LEGENDARY: 35,
  MYTHIC: 30,
  GALAXY: 20,
  NUCLEAR: 10
};

export const GOD_BOX_RATES_S2 = {
  COMMON: 5,
  LEGENDARY: 40,
  MYTHIC: 45,
  GALAXY: 10
};

export const GOD_BOX_RATES = GOD_BOX_RATES_S1;

// Rarity tier order for progression and display
export const RARITY_TIERS_S1 = ['COMMON', 'UNCOMMON', 'RARE', 'EPIC', 'LEGENDARY', 'MYTHIC', 'GALAXY', 'NUCLEAR'];
export const RARITY_TIERS_REVERSED_S1 = ['NUCLEAR', 'GALAXY', 'MYTHIC', 'LEGENDARY', 'EPIC', 'RARE', 'UNCOMMON', 'COMMON'];

export const RARITY_TIERS_S2 = ['COMMON', 'UNCOMMON', 'RARE', 'EPIC', 'LEGENDARY', 'MYTHIC', 'GALAXY', 'TESTER'];
export const RARITY_TIERS_REVERSED_S2 = ['TESTER', 'GALAXY', 'MYTHIC', 'LEGENDARY', 'EPIC', 'RARE', 'UNCOMMON', 'COMMON'];

export const RARITY_TIERS = RARITY_TIERS_S1;
export const RARITY_TIERS_REVERSED = RARITY_TIERS_REVERSED_S1;

// S2 probabilistic trade-up outcomes
export const S2_TRADEUP_PROBABILITIES = {
  PLUS_1: 0.50,   // +1 rarity
  SAME: 0.30,     // same rarity (different item)
  PLUS_2: 0.15,   // +2 rarities
  PLUS_3: 0.05,   // +3 rarities
};

// Maximum tradeable rarity (Legendary is highest, Mythic/Galaxy cannot be traded up)
export const S2_MAX_TRADEABLE_RARITY = 'LEGENDARY';

// S2 lootbox shop prices (crewmate tokens)
export const S2_LOOTBOX_PRICES = {
  normal: { single: 1, bulk: 8, bulkCount: 10 },
  shiny: { single: 3, bulk: 24, bulkCount: 10 },
  stattrak: { single: 3, bulk: 24, bulkCount: 10 },
  vfxbox: { single: 10, bulk: 80, bulkCount: 10 },
  elite: { single: 25 },
  god: { single: 100 },
};

// S2 impostor token lootbox prices (strict 4:1 ratio with crewmate prices)
export const S2_IMPOSTOR_LOOTBOX_PRICES = {
  normal: { bulk: 2, bulkCount: 10 },       // 8/4 = 2
  shiny: { bulk: 6, bulkCount: 10 },        // 24/4 = 6
  stattrak: { bulk: 6, bulkCount: 10 },     // 24/4 = 6
  vfxbox: { single: 2.5, bulk: 20, bulkCount: 10 }, // 10/4 = 2.5
  elite: { single: 6.25 },                  // 25/4 = 6.25
  god: { single: 25 },                      // 100/4 = 25
};

// S2 free daily lootbox count
export const S2_FREE_DAILY_BOXES = 3;

// S2 collection rewards (tokens — scaled to reflect collection difficulty)
export const S2_COLLECTION_REWARDS = {
  COMMON: { tokenType: 'crewmate', amount: 10 },
  UNCOMMON: { tokenType: 'crewmate', amount: 25 },
  RARE: { tokenType: 'impostor', amount: 5 },
  EPIC: { tokenType: 'impostor', amount: 15 },
  LEGENDARY: { tokenType: 'impostor', amount: 35 },
  MYTHIC: { tokenType: 'impostor', amount: 75 },
  GALAXY: { tokenType: 'impostor', amount: 150 },
};

// StatTrak available stats
export const STATTRAK_STATS = [
  'kills',
  'tasks_completed',
  'crewmate_wins',
  'imposter_wins',
  'wins',
  'crewmate_losses',
  'imposter_losses',
  'losses',
  'times_as_imposter',
  'times_as_crewmate',
  'games_played'
];

export const STATTRAK_LABELS = {
  kills: 'Kills',
  tasks_completed: 'Tasks Completed',
  crewmate_wins: 'Crewmate Wins',
  imposter_wins: 'Imposter Wins',
  wins: 'Wins',
  crewmate_losses: 'Crewmate Losses',
  imposter_losses: 'Imposter Losses',
  losses: 'Losses',
  times_as_imposter: 'Times Imposter',
  times_as_crewmate: 'Times Crewmate',
  games_played: 'Games Played'
};

// S1 items pool - 169 cosmetic emojis (includes nuclear)
export const LOOTBOX_ITEMS_S1 = [
  // Common items (75 total)
  { id: "common_1", name: "Red Heart", rarity: "COMMON", icon: "\u2764\uFE0F", description: "Classic heart emoji" },
  { id: "common_2", name: "Thumbs Up", rarity: "COMMON", icon: "\uD83D\uDC4D", description: "Positive vibes" },
  { id: "common_3", name: "Star", rarity: "COMMON", icon: "\u2B50", description: "Shining star" },
  { id: "common_4", name: "Smiley Face", rarity: "COMMON", icon: "\uD83D\uDE0A", description: "Happy face" },
  { id: "common_5", name: "Fire", rarity: "COMMON", icon: "\uD83D\uDD25", description: "On fire" },
  { id: "common_6", name: "Pizza", rarity: "COMMON", icon: "\uD83C\uDF55", description: "Delicious pizza" },
  { id: "common_7", name: "Coffee", rarity: "COMMON", icon: "\u2615", description: "Morning brew" },
  { id: "common_8", name: "Music Note", rarity: "COMMON", icon: "\uD83C\uDFB5", description: "Musical vibes" },
  { id: "common_9", name: "Soccer Ball", rarity: "COMMON", icon: "\u26BD", description: "Sports fan" },
  { id: "common_10", name: "Camera", rarity: "COMMON", icon: "\uD83D\uDCF7", description: "Photographer" },
  { id: "common_11", name: "Book", rarity: "COMMON", icon: "\uD83D\uDCDA", description: "Bookworm" },
  { id: "common_12", name: "Rocket", rarity: "COMMON", icon: "\uD83D\uDE80", description: "To the moon" },
  { id: "common_13", name: "Plant", rarity: "COMMON", icon: "\uD83C\uDF31", description: "Nature lover" },
  { id: "common_14", name: "Sun", rarity: "COMMON", icon: "\u2600\uFE0F", description: "Sunny day" },
  { id: "common_15", name: "Moon", rarity: "COMMON", icon: "\uD83C\uDF15", description: "Night owl" },
  { id: "common_16", name: "Cloud", rarity: "COMMON", icon: "\u2601\uFE0F", description: "Cloudy" },
  { id: "common_17", name: "Snowflake", rarity: "COMMON", icon: "\uD83C\uDF28\uFE0F", description: "Winter vibes" },
  { id: "common_18", name: "Balloon", rarity: "COMMON", icon: "\uD83C\uDF89", description: "Party time" },
  { id: "common_19", name: "Gift", rarity: "COMMON", icon: "\uD83C\uDF81", description: "Present" },
  { id: "common_20", name: "Clap", rarity: "COMMON", icon: "\uD83D\uDC4F", description: "Applause" },
  { id: "common_21", name: "Thinking", rarity: "COMMON", icon: "\uD83E\uDD14", description: "Thoughtful" },
  { id: "common_22", name: "Wink", rarity: "COMMON", icon: "\uD83D\uDE09", description: "Playful wink" },
  { id: "common_23", name: "Laugh", rarity: "COMMON", icon: "\uD83D\uDE02", description: "Laughing" },
  { id: "common_24", name: "Cool", rarity: "COMMON", icon: "\uD83D\uDE0E", description: "Cool emoji" },
  { id: "common_25", name: "Party", rarity: "COMMON", icon: "\uD83E\uDD73", description: "Celebration" },
  { id: "common_26", name: "Apple", rarity: "COMMON", icon: "\uD83C\uDF4E", description: "Healthy" },
  { id: "common_27", name: "Burger", rarity: "COMMON", icon: "\uD83C\uDF54", description: "Fast food" },
  { id: "common_28", name: "Ice Cream", rarity: "COMMON", icon: "\uD83C\uDF66", description: "Sweet treat" },
  { id: "common_29", name: "Donut", rarity: "COMMON", icon: "\uD83C\uDF69", description: "Glazed donut" },
  { id: "common_30", name: "Bicycle", rarity: "COMMON", icon: "\uD83D\uDEB2", description: "Cyclist" },
  { id: "common_31", name: "Car", rarity: "COMMON", icon: "\uD83D\uDE97", description: "Driver" },
  { id: "common_32", name: "Airplane", rarity: "COMMON", icon: "\u2708\uFE0F", description: "Traveler" },
  { id: "common_33", name: "House", rarity: "COMMON", icon: "\uD83C\uDFE0", description: "Home sweet home" },
  { id: "common_34", name: "Mountains", rarity: "COMMON", icon: "\u26F0\uFE0F", description: "Nature explorer" },
  { id: "common_35", name: "Beach", rarity: "COMMON", icon: "\uD83C\uDFD6\uFE0F", description: "Beach vibes" },
  { id: "common_36", name: "Cactus", rarity: "COMMON", icon: "\uD83C\uDF35", description: "Desert plant" },
  { id: "common_37", name: "Flower", rarity: "COMMON", icon: "\uD83C\uDF38", description: "Blooming" },
  { id: "common_38", name: "Butterfly", rarity: "COMMON", icon: "\uD83E\uDD8B", description: "Graceful" },
  { id: "common_39", name: "Dog", rarity: "COMMON", icon: "\uD83D\uDC36", description: "Dog lover" },
  { id: "common_40", name: "Cat", rarity: "COMMON", icon: "\uD83D\uDC08", description: "Cat person" },
  { id: "common_41", name: "Panda", rarity: "COMMON", icon: "\uD83D\uDC3C", description: "Cute panda" },
  { id: "common_42", name: "Koala", rarity: "COMMON", icon: "\uD83D\uDC28", description: "Sleepy koala" },
  { id: "common_43", name: "Frog", rarity: "COMMON", icon: "\uD83D\uDC38", description: "Ribbit" },
  { id: "common_44", name: "Fish", rarity: "COMMON", icon: "\uD83D\uDC1F", description: "Underwater" },
  { id: "common_45", name: "Lightbulb", rarity: "COMMON", icon: "\uD83D\uDCA1", description: "Bright idea" },
  { id: "common_46", name: "Trophy", rarity: "COMMON", icon: "\uD83C\uDFC6", description: "Winner" },
  { id: "common_47", name: "Medal", rarity: "COMMON", icon: "\uD83E\uDD47", description: "Champion" },
  { id: "common_48", name: "Dart", rarity: "COMMON", icon: "\uD83C\uDFAF", description: "On target" },
  { id: "common_49", name: "Game", rarity: "COMMON", icon: "\uD83C\uDFAE", description: "Gamer" },
  { id: "common_50", name: "Dice", rarity: "COMMON", icon: "\uD83C\uDFB2", description: "Lucky roll" },
  { id: "common_51", name: "Elephant", rarity: "COMMON", icon: "\uD83D\uDC18", description: "Never forgets" },
  { id: "common_52", name: "Monkey", rarity: "COMMON", icon: "\uD83D\uDC35", description: "Playful primate" },
  { id: "common_53", name: "Lion", rarity: "COMMON", icon: "\uD83E\uDD81", description: "King of jungle" },
  { id: "common_54", name: "Tiger", rarity: "COMMON", icon: "\uD83D\uDC2F", description: "Fierce feline" },
  { id: "common_55", name: "Bear", rarity: "COMMON", icon: "\uD83D\uDC3B", description: "Mighty bear" },
  { id: "common_56", name: "Penguin", rarity: "COMMON", icon: "\uD83D\uDC27", description: "Ice dweller" },
  { id: "common_57", name: "Owl", rarity: "COMMON", icon: "\uD83E\uDD89", description: "Wise bird" },
  { id: "common_58", name: "Eagle", rarity: "COMMON", icon: "\uD83E\uDD85", description: "Soaring high" },
  { id: "common_59", name: "Turtle", rarity: "COMMON", icon: "\uD83D\uDC22", description: "Slow and steady" },
  { id: "common_60", name: "Crab", rarity: "COMMON", icon: "\uD83E\uDD80", description: "Sideways walker" },
  { id: "common_61", name: "Octopus", rarity: "COMMON", icon: "\uD83D\uDC19", description: "Eight arms" },
  { id: "common_62", name: "Shark", rarity: "COMMON", icon: "\uD83E\uDD88", description: "Ocean predator" },
  { id: "common_63", name: "Dolphin", rarity: "COMMON", icon: "\uD83D\uDC2C", description: "Friendly mammal" },
  { id: "common_64", name: "Whale", rarity: "COMMON", icon: "\uD83D\uDC0B", description: "Ocean giant" },
  { id: "common_65", name: "Snake", rarity: "COMMON", icon: "\uD83D\uDC0D", description: "Slithering" },
  { id: "common_66", name: "Crocodile", rarity: "COMMON", icon: "\uD83D\uDC0A", description: "Swamp hunter" },
  { id: "common_67", name: "Bee", rarity: "COMMON", icon: "\uD83D\uDC1D", description: "Busy bee" },
  { id: "common_68", name: "Ladybug", rarity: "COMMON", icon: "\uD83D\uDC1E", description: "Lucky bug" },
  { id: "common_69", name: "Spider", rarity: "COMMON", icon: "\uD83D\uDD77\uFE0F", description: "Web spinner" },
  { id: "common_70", name: "Bat", rarity: "COMMON", icon: "\uD83E\uDD87", description: "Night flyer" },
  { id: "common_71", name: "Flamingo", rarity: "COMMON", icon: "\uD83E\uDDA9", description: "Pink bird" },
  { id: "common_72", name: "Peacock", rarity: "COMMON", icon: "\uD83E\uDD9A", description: "Colorful feathers" },
  { id: "common_73", name: "Parrot", rarity: "COMMON", icon: "\uD83E\uDD9C", description: "Talking bird" },
  { id: "common_74", name: "Mushroom", rarity: "COMMON", icon: "\uD83C\uDF44", description: "Forest fungus" },
  { id: "common_75", name: "Chili Pepper", rarity: "COMMON", icon: "\uD83C\uDF36\uFE0F", description: "Hot spice" },

  // Uncommon items (40 total)
  { id: "uncommon_1", name: "Rainbow", rarity: "UNCOMMON", icon: "\uD83C\uDF08", description: "Colorful arc" },
  { id: "uncommon_2", name: "Lightning", rarity: "UNCOMMON", icon: "\u26A1", description: "Electric" },
  { id: "uncommon_3", name: "Tornado", rarity: "UNCOMMON", icon: "\uD83C\uDF2A\uFE0F", description: "Whirlwind" },
  { id: "uncommon_4", name: "Volcano", rarity: "UNCOMMON", icon: "\uD83C\uDF0B", description: "Erupting" },
  { id: "uncommon_5", name: "Ghost", rarity: "UNCOMMON", icon: "\uD83D\uDC7B", description: "Spooky ghost" },
  { id: "uncommon_6", name: "Robot", rarity: "UNCOMMON", icon: "\uD83E\uDD16", description: "Mechanical" },
  { id: "uncommon_7", name: "Alien", rarity: "UNCOMMON", icon: "\uD83D\uDC7D", description: "Extraterrestrial" },
  { id: "uncommon_8", name: "Pirate", rarity: "UNCOMMON", icon: "\uD83C\uDFF4\u200D\u2620\uFE0F", description: "Pirate flag" },
  { id: "uncommon_9", name: "Samurai", rarity: "UNCOMMON", icon: "\uD83D\uDDE1\uFE0F", description: "Warrior code" },
  { id: "uncommon_10", name: "Wizard", rarity: "UNCOMMON", icon: "\uD83E\uDDD9", description: "Magic user" },
  { id: "uncommon_11", name: "Vampire", rarity: "UNCOMMON", icon: "\uD83E\uDDDB", description: "Night creature" },
  { id: "uncommon_12", name: "Zombie", rarity: "UNCOMMON", icon: "\uD83E\uDDDF", description: "Undead" },
  { id: "uncommon_13", name: "Mermaid", rarity: "UNCOMMON", icon: "\uD83E\uDDDC", description: "Ocean dweller" },
  { id: "uncommon_14", name: "Fairy", rarity: "UNCOMMON", icon: "\uD83E\uDDDA", description: "Magical being" },
  { id: "uncommon_15", name: "Crown", rarity: "UNCOMMON", icon: "\uD83D\uDC51", description: "Royalty" },
  { id: "uncommon_16", name: "Gem", rarity: "UNCOMMON", icon: "\uD83D\uDC8E", description: "Precious stone" },
  { id: "uncommon_17", name: "Ring", rarity: "UNCOMMON", icon: "\uD83D\uDC8D", description: "Jewelry" },
  { id: "uncommon_18", name: "Glasses", rarity: "UNCOMMON", icon: "\uD83D\uDC53", description: "Smart look" },
  { id: "uncommon_19", name: "Top Hat", rarity: "UNCOMMON", icon: "\uD83C\uDFA9", description: "Fancy hat" },
  { id: "uncommon_20", name: "Bow Tie", rarity: "UNCOMMON", icon: "\uD83C\uDF80", description: "Elegant" },
  { id: "uncommon_21", name: "Balloon Dog", rarity: "UNCOMMON", icon: "\uD83C\uDF88", description: "Party animal" },
  { id: "uncommon_22", name: "Fireworks", rarity: "UNCOMMON", icon: "\uD83C\uDF86", description: "Celebration" },
  { id: "uncommon_23", name: "Sparkler", rarity: "UNCOMMON", icon: "\uD83C\uDF87", description: "Sparkly" },
  { id: "uncommon_24", name: "Confetti", rarity: "UNCOMMON", icon: "\uD83C\uDF8A", description: "Party time" },
  { id: "uncommon_25", name: "Crystal Ball", rarity: "UNCOMMON", icon: "\uD83D\uDD2E", description: "Fortune teller" },
  { id: "uncommon_26", name: "Telescope", rarity: "UNCOMMON", icon: "\uD83D\uDD2D", description: "Stargazer" },
  { id: "uncommon_27", name: "Potion", rarity: "UNCOMMON", icon: "\uD83E\uDDEA", description: "Alchemist" },
  { id: "uncommon_28", name: "Scroll", rarity: "UNCOMMON", icon: "\uD83D\uDCDC", description: "Ancient text" },
  { id: "uncommon_29", name: "Key", rarity: "UNCOMMON", icon: "\uD83D\uDD11", description: "Unlock secrets" },
  { id: "uncommon_30", name: "Compass", rarity: "UNCOMMON", icon: "\uD83E\uDDED", description: "Navigator" },
  { id: "uncommon_31", name: "Anchor", rarity: "UNCOMMON", icon: "\u2693", description: "Ship's hold" },
  { id: "uncommon_32", name: "Shield", rarity: "UNCOMMON", icon: "\uD83D\uDEE1\uFE0F", description: "Protector" },
  { id: "uncommon_33", name: "Hourglass", rarity: "UNCOMMON", icon: "\u23F3", description: "Time flows" },
  { id: "uncommon_34", name: "Globe", rarity: "UNCOMMON", icon: "\uD83C\uDF10", description: "Worldly" },
  { id: "uncommon_35", name: "Diamond Heart", rarity: "UNCOMMON", icon: "\uD83D\uDC99", description: "Precious love" },
  { id: "uncommon_36", name: "Snowman", rarity: "UNCOMMON", icon: "\u26C4", description: "Winter friend" },
  { id: "uncommon_37", name: "Jack-o-Lantern", rarity: "UNCOMMON", icon: "\uD83C\uDF83", description: "Spooky pumpkin" },
  { id: "uncommon_38", name: "Christmas Tree", rarity: "UNCOMMON", icon: "\uD83C\uDF84", description: "Holiday spirit" },
  { id: "uncommon_39", name: "Shooting Star", rarity: "UNCOMMON", icon: "\uD83C\uDF20", description: "Make a wish" },
  { id: "uncommon_40", name: "Crescent Moon", rarity: "UNCOMMON", icon: "\uD83C\uDF19", description: "Night symbol" },

  // Rare items (24 total)
  { id: "rare_1", name: "Dragon", rarity: "RARE", icon: "\uD83D\uDC09", description: "Legendary beast" },
  { id: "rare_2", name: "Unicorn", rarity: "RARE", icon: "\uD83E\uDD84", description: "Mythical creature" },
  { id: "rare_3", name: "Celestial Halo", rarity: "RARE", icon: "\uD83D\uDE07", description: "Divine ascension" },
  { id: "rare_4", name: "Pegasus", rarity: "RARE", icon: "\uD83D\uDC34", description: "Flying horse" },
  { id: "rare_5", name: "Kraken", rarity: "RARE", icon: "\uD83E\uDD91", description: "Sea monster" },
  { id: "rare_6", name: "Cerberus", rarity: "RARE", icon: "\uD83D\uDC15", description: "Three-headed dog" },
  { id: "rare_7", name: "Space Helmet", rarity: "RARE", icon: "\uD83D\uDC68\u200D\uD83D\uDE80", description: "Astronaut" },
  { id: "rare_8", name: "UFO", rarity: "RARE", icon: "\uD83D\uDEF8", description: "Flying saucer" },
  { id: "rare_9", name: "Satellite", rarity: "RARE", icon: "\uD83D\uDEF0\uFE0F", description: "Space tech" },
  { id: "rare_10", name: "Galaxy", rarity: "RARE", icon: "\uD83C\uDF03", description: "Cosmic wonder" },
  { id: "rare_11", name: "Black Hole", rarity: "RARE", icon: "\uD83D\uDD73\uFE0F", description: "Void" },
  { id: "rare_12", name: "Comet", rarity: "RARE", icon: "\u2604\uFE0F", description: "Shooting star" },
  { id: "rare_13", name: "Hydra", rarity: "RARE", icon: "\uD83D\uDC32", description: "Many-headed serpent" },
  { id: "rare_14", name: "Basilisk", rarity: "RARE", icon: "\uD83D\uDC0D", description: "King of serpents" },
  { id: "rare_15", name: "Chimera", rarity: "RARE", icon: "\uD83E\uDD81", description: "Hybrid beast" },
  { id: "rare_16", name: "Griffon", rarity: "RARE", icon: "\uD83E\uDD85", description: "Eagle-lion" },
  { id: "rare_17", name: "Minotaur", rarity: "RARE", icon: "\uD83D\uDC02", description: "Bull-headed warrior" },
  { id: "rare_18", name: "Medusa", rarity: "RARE", icon: "\uD83D\uDC78", description: "Snake-haired gorgon" },
  { id: "rare_19", name: "Valkyrie", rarity: "RARE", icon: "\uD83E\uDDDD", description: "Chooser of slain" },
  { id: "rare_20", name: "Djinn", rarity: "RARE", icon: "\uD83E\uDDDE", description: "Wish granter" },
  { id: "rare_21", name: "Banshee", rarity: "RARE", icon: "\uD83D\uDC7B", description: "Wailing spirit" },
  { id: "rare_22", name: "Werewolf", rarity: "RARE", icon: "\uD83D\uDC3A", description: "Moon-cursed" },
  { id: "rare_23", name: "Ice Giant", rarity: "RARE", icon: "\u2744\uFE0F", description: "Frost titan" },
  { id: "rare_24", name: "Fire Elemental", rarity: "RARE", icon: "\uD83D\uDD06", description: "Living flame" },

  // Epic items (13 total)
  { id: "epic_1", name: "Infinity Stone", rarity: "EPIC", icon: "\uD83D\uDCA0", description: "Infinite power" },
  { id: "epic_2", name: "Time Turner", rarity: "EPIC", icon: "\u23F0", description: "Control time" },
  { id: "epic_3", name: "Arcane Scepter", rarity: "EPIC", icon: "\uD83D\uDD2E", description: "Immense power" },
  { id: "epic_4", name: "Excalibur", rarity: "EPIC", icon: "\u2694\uFE0F", description: "Legendary sword" },
  { id: "epic_5", name: "Mjolnir", rarity: "EPIC", icon: "\uD83D\uDD28", description: "Thor's hammer" },
  { id: "epic_6", name: "One Ring", rarity: "EPIC", icon: "\uD83D\uDC8D", description: "Rule them all" },
  { id: "epic_7", name: "Eternal Flame", rarity: "EPIC", icon: "\uD83D\uDD6F\uFE0F", description: "Never extinguished" },
  { id: "epic_8", name: "Solar Eclipse", rarity: "EPIC", icon: "\uD83C\uDF11", description: "Celestial alignment" },
  { id: "epic_9", name: "Ancient Grimoire", rarity: "EPIC", icon: "\uD83D\uDCD6", description: "Forbidden knowledge" },
  { id: "epic_10", name: "Crystal Skull", rarity: "EPIC", icon: "\uD83D\uDC80", description: "Ancient mystery" },
  { id: "epic_11", name: "Dragon Egg", rarity: "EPIC", icon: "\uD83E\uDD5A", description: "Unhatched legend" },
  { id: "epic_12", name: "Celestial Orb", rarity: "EPIC", icon: "\uD83C\uDF10", description: "Universal power" },
  { id: "epic_13", name: "Multiverse Key", rarity: "EPIC", icon: "\uD83D\uDDDD\uFE0F", description: "Opens all realities" },

  // Legendary items (8 total)
  { id: "legendary_1", name: "Philosopher's Stone", rarity: "LEGENDARY", icon: "\uD83D\uDD34", description: "Eternal life" },
  { id: "legendary_2", name: "Holy Grail", rarity: "LEGENDARY", icon: "\uD83C\uDFC6", description: "Divine cup" },
  { id: "legendary_3", name: "Ark of Covenant", rarity: "LEGENDARY", icon: "\uD83D\uDCE6", description: "Sacred artifact" },
  { id: "legendary_4", name: "Trident of Poseidon", rarity: "LEGENDARY", icon: "\uD83D\uDD31", description: "Ocean ruler" },
  { id: "legendary_5", name: "Crown of Immortality", rarity: "LEGENDARY", icon: "\uD83D\uDC51", description: "Eternal reign" },
  { id: "legendary_6", name: "Cosmic Eye", rarity: "LEGENDARY", icon: "\uD83D\uDC41\uFE0F", description: "All-seeing" },
  { id: "legendary_7", name: "Demon Skull", rarity: "LEGENDARY", icon: "\uD83D\uDE08", description: "Dark power" },
  { id: "legendary_8", name: "Stellar Crown", rarity: "LEGENDARY", icon: "\u269C\uFE0F", description: "Cosmic royalty" },

  // Mythic items (5 total - 0.1% drop rate)
  { id: "mythic_1", name: "Cosmic Singularity", rarity: "MYTHIC", icon: "\uD83C\uDF1F", description: "Reality bender" },
  { id: "mythic_2", name: "Void Crystal", rarity: "MYTHIC", icon: "\uD83D\uDC8E", description: "Dimension breaker" },
  { id: "mythic_3", name: "Phoenix", rarity: "MYTHIC", icon: "\uD83D\uDD25", description: "Eternal rebirth" },
  { id: "mythic_4", name: "Divine Poop", rarity: "MYTHIC", icon: "\uD83D\uDCA9", description: "Holy crap!" },
  { id: "mythic_5", name: "Thunderbolt", rarity: "MYTHIC", icon: "\uD83C\uDF29\uFE0F", description: "Zeus's wrath" },

  // Galaxy items (3 total - 0.01% drop rate) - ABSOLUTE MAXIMUM
  { id: "galaxy_1", name: "Nebula Core", rarity: "GALAXY", icon: "\uD83C\uDF0C", description: "Birth of stars" },
  { id: "galaxy_2", name: "Supernova", rarity: "GALAXY", icon: "\uD83D\uDCAB", description: "Stellar explosion" },
  { id: "galaxy_3", name: "Quasar", rarity: "GALAXY", icon: "\u2728", description: "Cosmic beacon" },

  // Nuclear tier (0.001% drop rate - 1 in 100,000)
  { id: "nuclear_1", name: "Nuclear Meltdown", rarity: "NUCLEAR", icon: "\u2622\uFE0F", description: "Ultimate destruction" },
];

// S2 items pool — 160 items (60C + 40U + 25R + 15E + 10L + 5M + 5G), no nuclear
export const LOOTBOX_ITEMS_S2 = [
  // Common items (60 total) — trimmed from 75, keeping most iconic
  { id: "common_1", name: "Red Heart", rarity: "COMMON", icon: "\u2764\uFE0F", description: "Classic heart emoji" },
  { id: "common_2", name: "Thumbs Up", rarity: "COMMON", icon: "\uD83D\uDC4D", description: "Positive vibes" },
  { id: "common_3", name: "Star", rarity: "COMMON", icon: "\u2B50", description: "Shining star" },
  { id: "common_4", name: "Smiley Face", rarity: "COMMON", icon: "\uD83D\uDE0A", description: "Happy face" },
  { id: "common_5", name: "Pepper", rarity: "COMMON", icon: "\uD83C\uDF36\uFE0F", description: "Spicy hot" },
  { id: "common_6", name: "Pizza", rarity: "COMMON", icon: "\uD83C\uDF55", description: "Delicious pizza" },
  { id: "common_7", name: "Coffee", rarity: "COMMON", icon: "\u2615", description: "Morning brew" },
  { id: "common_8", name: "Music Note", rarity: "COMMON", icon: "\uD83C\uDFB5", description: "Musical vibes" },
  { id: "common_9", name: "Soccer Ball", rarity: "COMMON", icon: "\u26BD", description: "Sports fan" },
  { id: "common_10", name: "Camera", rarity: "COMMON", icon: "\uD83D\uDCF7", description: "Photographer" },
  { id: "common_11", name: "Book", rarity: "COMMON", icon: "\uD83D\uDCDA", description: "Bookworm" },
  { id: "common_12", name: "Rocket", rarity: "COMMON", icon: "\uD83D\uDE80", description: "To the moon" },
  { id: "common_13", name: "Plant", rarity: "COMMON", icon: "\uD83C\uDF31", description: "Nature lover" },
  { id: "common_14", name: "Sun", rarity: "COMMON", icon: "\u2600\uFE0F", description: "Sunny day" },
  { id: "common_15", name: "Moon", rarity: "COMMON", icon: "\uD83C\uDF15", description: "Night owl" },
  { id: "common_16", name: "Cloud", rarity: "COMMON", icon: "\u2601\uFE0F", description: "Cloudy" },
  { id: "common_17", name: "Snowflake", rarity: "COMMON", icon: "\uD83C\uDF28\uFE0F", description: "Winter vibes" },
  { id: "common_18", name: "Balloon", rarity: "COMMON", icon: "\uD83C\uDF89", description: "Party time" },
  { id: "common_19", name: "Gift", rarity: "COMMON", icon: "\uD83C\uDF81", description: "Present" },
  { id: "common_20", name: "Clap", rarity: "COMMON", icon: "\uD83D\uDC4F", description: "Applause" },
  { id: "common_21", name: "Thinking", rarity: "COMMON", icon: "\uD83E\uDD14", description: "Thoughtful" },
  { id: "common_22", name: "Wink", rarity: "COMMON", icon: "\uD83D\uDE09", description: "Playful wink" },
  { id: "common_23", name: "Laugh", rarity: "COMMON", icon: "\uD83D\uDE02", description: "Laughing" },
  { id: "common_24", name: "Cool", rarity: "COMMON", icon: "\uD83D\uDE0E", description: "Cool emoji" },
  { id: "common_25", name: "Party", rarity: "COMMON", icon: "\uD83E\uDD73", description: "Celebration" },
  { id: "common_26", name: "Apple", rarity: "COMMON", icon: "\uD83C\uDF4E", description: "Healthy" },
  { id: "common_27", name: "Burger", rarity: "COMMON", icon: "\uD83C\uDF54", description: "Fast food" },
  { id: "common_28", name: "Ice Cream", rarity: "COMMON", icon: "\uD83C\uDF66", description: "Sweet treat" },
  { id: "common_29", name: "Donut", rarity: "COMMON", icon: "\uD83C\uDF69", description: "Glazed donut" },
  { id: "common_30", name: "Bicycle", rarity: "COMMON", icon: "\uD83D\uDEB2", description: "Cyclist" },
  { id: "common_31", name: "Car", rarity: "COMMON", icon: "\uD83D\uDE97", description: "Driver" },
  { id: "common_32", name: "Airplane", rarity: "COMMON", icon: "\u2708\uFE0F", description: "Traveler" },
  { id: "common_33", name: "House", rarity: "COMMON", icon: "\uD83C\uDFE0", description: "Home sweet home" },
  { id: "common_34", name: "Mountains", rarity: "COMMON", icon: "\u26F0\uFE0F", description: "Nature explorer" },
  { id: "common_35", name: "Beach", rarity: "COMMON", icon: "\uD83C\uDFD6\uFE0F", description: "Beach vibes" },
  { id: "common_36", name: "Cactus", rarity: "COMMON", icon: "\uD83C\uDF35", description: "Desert plant" },
  { id: "common_37", name: "Flower", rarity: "COMMON", icon: "\uD83C\uDF38", description: "Blooming" },
  { id: "common_38", name: "Butterfly", rarity: "COMMON", icon: "\uD83E\uDD8B", description: "Graceful" },
  { id: "common_39", name: "Dog", rarity: "COMMON", icon: "\uD83D\uDC36", description: "Dog lover" },
  { id: "common_40", name: "Cat", rarity: "COMMON", icon: "\uD83D\uDC08", description: "Cat person" },
  { id: "common_41", name: "Panda", rarity: "COMMON", icon: "\uD83D\uDC3C", description: "Cute panda" },
  { id: "common_42", name: "Frog", rarity: "COMMON", icon: "\uD83D\uDC38", description: "Ribbit" },
  { id: "common_43", name: "Fish", rarity: "COMMON", icon: "\uD83D\uDC1F", description: "Underwater" },
  { id: "common_44", name: "Lightbulb", rarity: "COMMON", icon: "\uD83D\uDCA1", description: "Bright idea" },
  { id: "common_45", name: "Trophy", rarity: "COMMON", icon: "\uD83C\uDFC6", description: "Winner" },
  { id: "common_46", name: "Dart", rarity: "COMMON", icon: "\uD83C\uDFAF", description: "On target" },
  { id: "common_47", name: "Game", rarity: "COMMON", icon: "\uD83C\uDFAE", description: "Gamer" },
  { id: "common_48", name: "Dice", rarity: "COMMON", icon: "\uD83C\uDFB2", description: "Lucky roll" },
  { id: "common_49", name: "Lion", rarity: "COMMON", icon: "\uD83E\uDD81", description: "King of jungle" },
  { id: "common_50", name: "Tiger", rarity: "COMMON", icon: "\uD83D\uDC2F", description: "Fierce feline" },
  { id: "common_51", name: "Bear", rarity: "COMMON", icon: "\uD83D\uDC3B", description: "Mighty bear" },
  { id: "common_52", name: "Penguin", rarity: "COMMON", icon: "\uD83D\uDC27", description: "Ice dweller" },
  { id: "common_53", name: "Owl", rarity: "COMMON", icon: "\uD83E\uDD89", description: "Wise bird" },
  { id: "common_54", name: "Eagle", rarity: "COMMON", icon: "\uD83E\uDD85", description: "Soaring high" },
  { id: "common_55", name: "Turtle", rarity: "COMMON", icon: "\uD83D\uDC22", description: "Slow and steady" },
  { id: "common_56", name: "Shark", rarity: "COMMON", icon: "\uD83E\uDD88", description: "Ocean predator" },
  { id: "common_57", name: "Dolphin", rarity: "COMMON", icon: "\uD83D\uDC2C", description: "Friendly mammal" },
  { id: "common_58", name: "Whale", rarity: "COMMON", icon: "\uD83D\uDC0B", description: "Ocean giant" },
  { id: "common_59", name: "Bee", rarity: "COMMON", icon: "\uD83D\uDC1D", description: "Busy bee" },
  { id: "common_60", name: "Mushroom", rarity: "COMMON", icon: "\uD83C\uDF44", description: "Forest fungus" },

  // Uncommon items (40 total) — same as S1
  { id: "uncommon_1", name: "Rainbow", rarity: "UNCOMMON", icon: "\uD83C\uDF08", description: "Colorful arc" },
  { id: "uncommon_2", name: "Lightning", rarity: "UNCOMMON", icon: "\uD83C\uDF29\uFE0F", description: "Electric" },
  { id: "uncommon_3", name: "Tornado", rarity: "UNCOMMON", icon: "\uD83C\uDF2A\uFE0F", description: "Whirlwind" },
  { id: "uncommon_4", name: "Volcano", rarity: "UNCOMMON", icon: "\uD83C\uDF0B", description: "Erupting" },
  { id: "uncommon_5", name: "Ghost", rarity: "UNCOMMON", icon: "\uD83D\uDC7B", description: "Spooky ghost" },
  { id: "uncommon_6", name: "Robot", rarity: "UNCOMMON", icon: "\uD83E\uDD16", description: "Mechanical" },
  { id: "uncommon_7", name: "Alien", rarity: "UNCOMMON", icon: "\uD83D\uDC7D", description: "Extraterrestrial" },
  { id: "uncommon_8", name: "Pirate", rarity: "UNCOMMON", icon: "\uD83C\uDFF4\u200D\u2620\uFE0F", description: "Pirate flag" },
  { id: "uncommon_9", name: "Ninja", rarity: "UNCOMMON", icon: "\uD83D\uDC64", description: "Shadow warrior" },
  { id: "uncommon_10", name: "Wizard", rarity: "UNCOMMON", icon: "\uD83E\uDDD9", description: "Magic user" },
  { id: "uncommon_11", name: "Vampire", rarity: "UNCOMMON", icon: "\uD83E\uDDDB", description: "Night creature" },
  { id: "uncommon_12", name: "Zombie", rarity: "UNCOMMON", icon: "\uD83E\uDDDF", description: "Undead" },
  { id: "uncommon_13", name: "Mermaid", rarity: "UNCOMMON", icon: "\uD83E\uDDDC", description: "Ocean dweller" },
  { id: "uncommon_14", name: "Fairy", rarity: "UNCOMMON", icon: "\uD83E\uDDDA", description: "Magical being" },
  { id: "uncommon_15", name: "Crown", rarity: "UNCOMMON", icon: "\uD83D\uDC51", description: "Royalty" },
  { id: "uncommon_16", name: "Gem", rarity: "UNCOMMON", icon: "\uD83D\uDC8E", description: "Precious stone" },
  { id: "uncommon_17", name: "Ring", rarity: "UNCOMMON", icon: "\uD83D\uDC8D", description: "Jewelry" },
  { id: "uncommon_18", name: "Glasses", rarity: "UNCOMMON", icon: "\uD83D\uDC53", description: "Smart look" },
  { id: "uncommon_19", name: "Top Hat", rarity: "UNCOMMON", icon: "\uD83C\uDFA9", description: "Fancy hat" },
  { id: "uncommon_20", name: "Bow Tie", rarity: "UNCOMMON", icon: "\uD83C\uDF80", description: "Elegant" },
  { id: "uncommon_21", name: "Balloon Dog", rarity: "UNCOMMON", icon: "\uD83C\uDF88", description: "Party animal" },
  { id: "uncommon_22", name: "Fireworks", rarity: "UNCOMMON", icon: "\uD83C\uDF86", description: "Celebration" },
  { id: "uncommon_23", name: "Sparkler", rarity: "UNCOMMON", icon: "\uD83C\uDF87", description: "Sparkly" },
  { id: "uncommon_24", name: "Confetti", rarity: "UNCOMMON", icon: "\uD83C\uDF8A", description: "Party time" },
  { id: "uncommon_25", name: "Crystal Ball", rarity: "UNCOMMON", icon: "\uD83D\uDD2E", description: "Fortune teller" },
  { id: "uncommon_26", name: "Telescope", rarity: "UNCOMMON", icon: "\uD83D\uDD2D", description: "Stargazer" },
  { id: "uncommon_27", name: "Potion", rarity: "UNCOMMON", icon: "\uD83E\uDDEA", description: "Alchemist" },
  { id: "uncommon_28", name: "Scroll", rarity: "UNCOMMON", icon: "\uD83D\uDCDC", description: "Ancient text" },
  { id: "uncommon_29", name: "Key", rarity: "UNCOMMON", icon: "\uD83D\uDD11", description: "Unlock secrets" },
  { id: "uncommon_30", name: "Compass", rarity: "UNCOMMON", icon: "\uD83E\uDDED", description: "Navigator" },
  { id: "uncommon_31", name: "Anchor", rarity: "UNCOMMON", icon: "\u2693", description: "Ship's hold" },
  { id: "uncommon_32", name: "Shield", rarity: "UNCOMMON", icon: "\uD83D\uDEE1\uFE0F", description: "Protector" },
  { id: "uncommon_33", name: "Hourglass", rarity: "UNCOMMON", icon: "\u23F3", description: "Time flows" },
  { id: "uncommon_34", name: "Globe", rarity: "UNCOMMON", icon: "\uD83C\uDF10", description: "Worldly" },
  { id: "uncommon_35", name: "Diamond Heart", rarity: "UNCOMMON", icon: "\uD83D\uDC99", description: "Precious love" },
  { id: "uncommon_36", name: "Snowman", rarity: "UNCOMMON", icon: "\u26C4", description: "Winter friend" },
  { id: "uncommon_37", name: "Jack-o-Lantern", rarity: "UNCOMMON", icon: "\uD83C\uDF83", description: "Spooky pumpkin" },
  { id: "uncommon_38", name: "Christmas Tree", rarity: "UNCOMMON", icon: "\uD83C\uDF84", description: "Holiday spirit" },
  { id: "uncommon_39", name: "Shooting Star", rarity: "UNCOMMON", icon: "\uD83C\uDF20", description: "Make a wish" },
  { id: "uncommon_40", name: "Crescent Moon", rarity: "UNCOMMON", icon: "\uD83C\uDF19", description: "Night symbol" },

  // Rare items (25 total) — no duplicate icons
  { id: "rare_1", name: "Leviathan", rarity: "RARE", icon: "\uD83D\uDC0A", description: "Sea beast" },
  { id: "rare_2", name: "Unicorn", rarity: "RARE", icon: "\uD83E\uDD84", description: "Mythical creature" },
  { id: "rare_3", name: "Celestial Halo", rarity: "RARE", icon: "\uD83D\uDE07", description: "Divine ascension" },
  { id: "rare_4", name: "Pegasus", rarity: "RARE", icon: "\uD83D\uDC34", description: "Flying horse" },
  { id: "rare_5", name: "Kraken", rarity: "RARE", icon: "\uD83E\uDD91", description: "Sea monster" },
  { id: "rare_6", name: "Cerberus", rarity: "RARE", icon: "\uD83D\uDC15", description: "Three-headed dog" },
  { id: "rare_7", name: "Space Helmet", rarity: "RARE", icon: "\uD83D\uDC68\u200D\uD83D\uDE80", description: "Astronaut" },
  { id: "rare_8", name: "UFO", rarity: "RARE", icon: "\uD83D\uDEF8", description: "Flying saucer" },
  { id: "rare_9", name: "Satellite", rarity: "RARE", icon: "\uD83D\uDEF0\uFE0F", description: "Space tech" },
  { id: "rare_10", name: "Starry Night", rarity: "RARE", icon: "\uD83C\uDF03", description: "Cosmic wonder" },
  { id: "rare_11", name: "Black Hole", rarity: "RARE", icon: "\uD83D\uDD73\uFE0F", description: "Void" },
  { id: "rare_12", name: "Centaur", rarity: "RARE", icon: "\uD83C\uDFC7", description: "Half-man half-horse" },
  { id: "rare_13", name: "Wraith", rarity: "RARE", icon: "\u26B0\uFE0F", description: "Restless spirit" },
  { id: "rare_14", name: "Basilisk", rarity: "RARE", icon: "\uD83D\uDC0D", description: "King of serpents" },
  { id: "rare_15", name: "Chimera", rarity: "RARE", icon: "\uD83E\uDD96", description: "Hybrid beast" },
  { id: "rare_16", name: "Griffon", rarity: "RARE", icon: "\uD83D\uDC3E", description: "Eagle-lion" },
  { id: "rare_17", name: "Minotaur", rarity: "RARE", icon: "\uD83D\uDC02", description: "Bull-headed warrior" },
  { id: "rare_18", name: "Phantom", rarity: "RARE", icon: "\uD83D\uDC65", description: "Unseen stalker" },
  { id: "rare_19", name: "Valkyrie", rarity: "RARE", icon: "\uD83E\uDDDD", description: "Chooser of slain" },
  { id: "rare_20", name: "Djinn", rarity: "RARE", icon: "\uD83E\uDDDE", description: "Wish granter" },
  { id: "rare_21", name: "Banshee", rarity: "RARE", icon: "\uD83D\uDC7A", description: "Wailing spirit" },
  { id: "rare_22", name: "Werewolf", rarity: "RARE", icon: "\uD83D\uDC3A", description: "Moon-cursed" },
  { id: "rare_23", name: "Ice Giant", rarity: "RARE", icon: "\u2744\uFE0F", description: "Frost titan" },
  { id: "rare_24", name: "Fire Elemental", rarity: "RARE", icon: "\uD83D\uDD06", description: "Living flame" },
  { id: "rare_25", name: "Thunderbird", rarity: "RARE", icon: "\uD83C\uDF29\uFE0F", description: "Storm bringer" },

  // Epic items (15 total) — no duplicate icons
  { id: "epic_1", name: "Oni", rarity: "EPIC", icon: "👹", description: "Demon warrior" },
  { id: "epic_2", name: "Black Widow", rarity: "EPIC", icon: "🕷️", description: "Deadly weaver" },
  { id: "epic_3", name: "Arcane Scepter", rarity: "EPIC", icon: "\uD83D\uDCAB", description: "Immense power" },
  { id: "epic_4", name: "Excalibur", rarity: "EPIC", icon: "\u2694\uFE0F", description: "Legendary sword" },
  { id: "epic_5", name: "Artemis", rarity: "EPIC", icon: "🏹", description: "Divine huntress" },
  { id: "epic_6", name: "Medusa", rarity: "EPIC", icon: "\uD83D\uDDFF", description: "Stone gaze" },
  { id: "epic_7", name: "Demon", rarity: "EPIC", icon: "👿", description: "Pure evil" },
  { id: "epic_8", name: "Solar Eclipse", rarity: "EPIC", icon: "\uD83C\uDF1E", description: "Celestial alignment" },
  { id: "epic_9", name: "Nightwing", rarity: "EPIC", icon: "🦇", description: "Lord of darkness" },
  { id: "epic_10", name: "Wild Card", rarity: "EPIC", icon: "🃏", description: "Chaos dealer" },
  { id: "epic_11", name: "Primal", rarity: "EPIC", icon: "🦍", description: "Raw power" },
  { id: "epic_12", name: "Celestial Orb", rarity: "EPIC", icon: "\uD83E\uDE90", description: "Universal power" },
  { id: "epic_13", name: "Comet", rarity: "EPIC", icon: "\u2604\uFE0F", description: "Blazing trail" },
  { id: "epic_14", name: "Hydra", rarity: "EPIC", icon: "\uD83D\uDC32", description: "Many-headed serpent" },
  { id: "epic_15", name: "Jormungandr", rarity: "EPIC", icon: "\uD83C\uDF0A", description: "World-encircling serpent" },

  // Legendary items (10 total) — iconic, universally cool emojis
  { id: "legendary_1", name: "Thunderstrike", rarity: "LEGENDARY", icon: "\u26A1", description: "Raw electric power" },
  { id: "legendary_2", name: "Perfection", rarity: "LEGENDARY", icon: "\uD83D\uDCAF", description: "Flawless" },
  { id: "legendary_3", name: "Death's Grasp", rarity: "LEGENDARY", icon: "\uD83D\uDC80", description: "Mortality itself" },
  { id: "legendary_4", name: "Inferno", rarity: "LEGENDARY", icon: "\uD83D\uDD25", description: "All-consuming flame" },
  { id: "legendary_5", name: "Poseidon's Wrath", rarity: "LEGENDARY", icon: "\uD83D\uDD31", description: "Ocean ruler" },
  { id: "legendary_6", name: "Armageddon", rarity: "LEGENDARY", icon: "\uD83D\uDCA3", description: "Total destruction" },
  { id: "legendary_7", name: "Godslayer", rarity: "LEGENDARY", icon: "\uD83D\uDDE1\uFE0F", description: "Kills gods" },
  { id: "legendary_8", name: "Blood Pact", rarity: "LEGENDARY", icon: "\uD83E\uDE78", description: "Sealed in blood" },
  { id: "legendary_9", name: "Dragon Lord", rarity: "LEGENDARY", icon: "\uD83D\uDC09", description: "Ancient dragon" },
  { id: "legendary_10", name: "Scorpion King", rarity: "LEGENDARY", icon: "\uD83E\uDD82", description: "Venomous ruler" },

  // Mythic items (5 total) — SVG crewmate art
  { id: "mythic_1", name: "Flame Crewmate", rarity: "MYTHIC", icon: "\uD83D\uDD25", description: "Born of fire", svgArt: true },
  { id: "mythic_2", name: "Crystal Crewmate", rarity: "MYTHIC", icon: "\uD83D\uDC8E", description: "Diamond-hard", svgArt: true },
  { id: "mythic_3", name: "Void Crewmate", rarity: "MYTHIC", icon: "\uD83C\uDF11", description: "From the abyss", svgArt: true },
  { id: "mythic_4", name: "Storm Crewmate", rarity: "MYTHIC", icon: "\u26C8\uFE0F", description: "Thunder within", svgArt: true },
  { id: "mythic_5", name: "Golden Crewmate", rarity: "MYTHIC", icon: "\uD83D\uDC51", description: "Pure gold", svgArt: true },

  // Galaxy items (5 total) — SVG crewmate art
  { id: "galaxy_1", name: "Nebula Core", rarity: "GALAXY", icon: "\uD83C\uDF0C", description: "Birth of stars", svgArt: true },
  { id: "galaxy_2", name: "Supernova", rarity: "GALAXY", icon: "\uD83D\uDCAB", description: "Stellar explosion", svgArt: true },
  { id: "galaxy_3", name: "Quasar", rarity: "GALAXY", icon: "\u2728", description: "Cosmic beacon", svgArt: true },
  { id: "galaxy_4", name: "Dark Matter", rarity: "GALAXY", icon: "\u2B1B", description: "Unseen force", svgArt: true },
  { id: "galaxy_5", name: "Event Horizon", rarity: "GALAXY", icon: "\uD83C\uDF00", description: "Point of no return", svgArt: true },
];

// Default items export — S1 for backwards compat
export const LOOTBOX_ITEMS = LOOTBOX_ITEMS_S1;

// Helper to get the right items pool
export function getLootboxItems() {
  return LOOTBOX_ITEMS_S2;
}

// Helper to get the right rarities
export function getLootboxRarities() {
  return LOOTBOX_RARITIES_S2;
}

// Helper to get rarity tiers
export function getRarityTiers() {
  return RARITY_TIERS_S2;
}

// Helper to get elite rates
export function getEliteRates() {
  return ELITE_LOOTBOX_RATES_S2;
}

// Helper to get god box rates
export function getGodBoxRates() {
  return GOD_BOX_RATES_S2;
}

// Rarities that are guaranteed shiny in S1 (shiny multiplier doesn't apply for liquidation)
const S1_GUARANTEED_SHINY = new Set(['MYTHIC', 'GALAXY', 'NUCLEAR']);

// Calculate S2 item networth value including modifiers
// skipGuaranteedShiny: when true, ignores shiny multiplier for S1 guaranteed-shiny rarities
export function getS2ItemValue(item, { skipGuaranteedShiny = false } = {}) {
  if (!item) return 0;
  const baseValue = S2_ITEM_VALUES[item.rarity] || 0;
  let multiplier = 1;
  if (item.isShiny) {
    const isGuaranteed = skipGuaranteedShiny && S1_GUARANTEED_SHINY.has(item.rarity);
    if (!isGuaranteed) multiplier *= S2_MODIFIER_MULTIPLIERS.shiny;
  }
  if (item.vfx) multiplier *= S2_MODIFIER_MULTIPLIERS.vfx;
  if (item.isStatTrak && item.trackedStats && item.trackedStats.length > 0) {
    multiplier *= (1.5 + 0.5 * (item.trackedStats.length - 1));
  }
  return baseValue * multiplier;
}

// Pass-exclusive items — NOT in lootbox drop pool, only obtainable from pass tiers
// All pass items use SVG crewmate art (svgArt: true)
export const PASS_EXCLUSIVE_ITEMS = [
  // CrewPass exclusives — blue/cyan themed crewmates, escalating effects
  { id: "crew_pass_10", name: "Crew Cadet", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 10", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_20", name: "Crew Scout", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 20", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_25", name: "Crew Knight", rarity: "LEGENDARY", icon: "🔵", description: "CrewPass Tier 25", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_30", name: "Crew Sentinel", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 30", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_40", name: "Crew Guardian", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 40", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_50", name: "Crew Paladin", rarity: "LEGENDARY", icon: "🔵", description: "CrewPass Tier 50", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_60", name: "Crew Warden", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 60", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_70", name: "Crew Commander", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 70", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_75", name: "Crew Archon", rarity: "LEGENDARY", icon: "🔵", description: "CrewPass Tier 75", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_80", name: "Crew Overlord", rarity: "EPIC", icon: "🔵", description: "CrewPass Tier 80", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_90", name: "Crew Ascendant", rarity: "LEGENDARY", icon: "🔵", description: "CrewPass Tier 90", passExclusive: "crew", svgArt: true },
  { id: "crew_pass_100", name: "Crew Champion", rarity: "LEGENDARY", icon: "🔵", description: "CrewPass Tier 100", passExclusive: "crew", svgArt: true },

  // ImpostorPass exclusives — red/dark themed crewmates, escalating effects
  { id: "impostor_pass_10", name: "Shadow Recruit", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 10", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_20", name: "Shadow Stalker", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 20", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_25", name: "Blood Moon", rarity: "LEGENDARY", icon: "🔴", description: "ImpostorPass Tier 25", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_30", name: "Shadow Fang", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 30", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_40", name: "Shadow Reaver", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 40", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_50", name: "Death Dealer", rarity: "LEGENDARY", icon: "🔴", description: "ImpostorPass Tier 50", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_60", name: "Shadow Wraith", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 60", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_70", name: "Shadow Phantom", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 70", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_75", name: "Void Assassin", rarity: "LEGENDARY", icon: "🔴", description: "ImpostorPass Tier 75", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_80", name: "Shadow Tyrant", rarity: "EPIC", icon: "🔴", description: "ImpostorPass Tier 80", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_90", name: "Shadow Emperor", rarity: "LEGENDARY", icon: "🔴", description: "ImpostorPass Tier 90", passExclusive: "impostor", svgArt: true },
  { id: "impostor_pass_100", name: "Impostor Lord", rarity: "LEGENDARY", icon: "🔴", description: "ImpostorPass Tier 100", passExclusive: "impostor", svgArt: true },
];

// S1 Rank Reward items — given at season transition based on highest overall rank
// Players receive ALL items at or below their rank (cumulative)
export const S1_RANK_REWARD_ITEMS = [
  { id: "s1_rank_crewling", name: "S1 Crewling", rarity: "COMMON", icon: "⭐", description: "Season 1 Crewling", svgArt: true, rankReward: true },
  { id: "s1_rank_wood", name: "S1 Wood", rarity: "COMMON", icon: "⭐", description: "Season 1 Wood", svgArt: true, rankReward: true },
  { id: "s1_rank_copper", name: "S1 Copper", rarity: "UNCOMMON", icon: "⭐", description: "Season 1 Copper", svgArt: true, rankReward: true },
  { id: "s1_rank_bronze", name: "S1 Bronze", rarity: "UNCOMMON", icon: "⭐", description: "Season 1 Bronze", svgArt: true, rankReward: true },
  { id: "s1_rank_silver", name: "S1 Silver", rarity: "RARE", icon: "⭐", description: "Season 1 Silver", svgArt: true, rankReward: true },
  { id: "s1_rank_gold", name: "S1 Gold", rarity: "RARE", icon: "⭐", description: "Season 1 Gold", svgArt: true, rankReward: true },
  { id: "s1_rank_diamond", name: "S1 Diamond", rarity: "EPIC", icon: "⭐", description: "Season 1 Diamond", svgArt: true, rankReward: true },
  { id: "s1_rank_master", name: "S1 Master", rarity: "EPIC", icon: "⭐", description: "Season 1 Master", svgArt: true, rankReward: true },
  { id: "s1_rank_grandmaster", name: "S1 Grand Master", rarity: "LEGENDARY", icon: "⭐", description: "Season 1 Grand Master", svgArt: true, rankReward: true },
  { id: "s1_rank_lord", name: "S1 Among Us Lord", rarity: "LEGENDARY", icon: "⭐", description: "Season 1 Among Us Lord", svgArt: true, rankReward: true },
];

// S2 Rank Reward items — given at season transition based on highest overall rank
// Players receive ALL items at or below their rank (cumulative)
export const S2_RANK_REWARD_ITEMS = [
  { id: "s2_rank_crewling", name: "S2 Crewling", rarity: "COMMON", icon: "⭐", description: "Season 2 Crewling", svgArt: true, rankReward: true },
  { id: "s2_rank_wood", name: "S2 Wood", rarity: "COMMON", icon: "⭐", description: "Season 2 Wood", svgArt: true, rankReward: true },
  { id: "s2_rank_copper", name: "S2 Copper", rarity: "UNCOMMON", icon: "⭐", description: "Season 2 Copper", svgArt: true, rankReward: true },
  { id: "s2_rank_bronze", name: "S2 Bronze", rarity: "UNCOMMON", icon: "⭐", description: "Season 2 Bronze", svgArt: true, rankReward: true },
  { id: "s2_rank_silver", name: "S2 Silver", rarity: "RARE", icon: "⭐", description: "Season 2 Silver", svgArt: true, rankReward: true },
  { id: "s2_rank_gold", name: "S2 Gold", rarity: "RARE", icon: "⭐", description: "Season 2 Gold", svgArt: true, rankReward: true },
  { id: "s2_rank_diamond", name: "S2 Diamond", rarity: "EPIC", icon: "⭐", description: "Season 2 Diamond", svgArt: true, rankReward: true },
  { id: "s2_rank_master", name: "S2 Master", rarity: "EPIC", icon: "⭐", description: "Season 2 Master", svgArt: true, rankReward: true },
  { id: "s2_rank_grandmaster", name: "S2 Grand Master", rarity: "LEGENDARY", icon: "⭐", description: "Season 2 Grand Master", svgArt: true, rankReward: true },
  { id: "s2_rank_lord", name: "S2 Among Us Lord", rarity: "LEGENDARY", icon: "⭐", description: "Season 2 Among Us Lord", svgArt: true, rankReward: true },
];
